import React from 'react';
import PropTypes from 'prop-types';
import { Box, Inline, Stack, Text } from '@stitch-fix/mode-react';
import './styles.module.scss';
import { ReactComponent as MensMeasurements } from './mens_full_measurement.svg';
import { ReactComponent as WomensMeasurements } from './womens_full_measurement.svg';

const HowToMeasure = ({ businessLine }: { businessLine: string | null }) => {
  const listItems = () => {
    if (businessLine === 'WOMENS') {
      return [
        {
          title: 'Bust',
          body: 'Measure under your arms and around the fullest part of your chest. (Bust is not your bra size.)',
        },
        {
          title: 'Waist',
          body: 'Measure around your natural waistline, between your navel and rib cage.',
        },
        {
          title: 'Hips',
          body: 'Stand with your feet together and measure around the fullest part of your hips.',
        },
        {
          title: 'Inseam',
          body: 'Measure from the top of the inside of your leg (at the crotch) down to the top of your heel.',
        },
      ];
    }

    return [
      {
        title: 'Neck',
        body: 'Measure the circumference of your neck about an inch above your collarbone.',
      },
      {
        title: 'Chest',
        body: 'With the tape below your arms, measure the broadest part of your chest.',
      },
      {
        title: 'Waist',
        body: 'Measure your waistline which lies between your belly button and rib cage.',
      },
      {
        title: 'Arm Length',
        body: 'With your elbow slightly bent, measure from the center back of your neck over your shoulder and elbow down to your wrist.',
      },
      {
        title: 'Inseam',
        body: 'Measure from the top of the inside of your leg at the crotch, down to the top of the heel.',
      },
    ];
  };

  return (
    <Box data-testid="how-to-measure-container">
      <Box
        mb={1.5}
        style={{
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        {businessLine === 'WOMENS' ? (
          <WomensMeasurements title="Women's measurements" aria-hidden="true" />
        ) : (
          <MensMeasurements title="Men's measurements" aria-hidden="true" />
        )}
      </Box>
      <Stack as="ol" spacing={1.5}>
        {listItems().map((listItem, index) => (
          <Inline spacing="6px" key={listItem.title}>
            <Box styleName="number">{index + 1}</Box>
            <Stack spacing={0}>
              <Text height="standard" family="medium" scale="4">
                {listItem.title}
              </Text>
              <Text height="tall" family="regular" scale="3">
                {listItem.body}
              </Text>
            </Stack>
          </Inline>
        ))}
      </Stack>
    </Box>
  );
};

HowToMeasure.propTypes = {
  businessLine: PropTypes.string.isRequired,
};

export default HowToMeasure;
